import React from "react";
import { useSearchParams } from "react-router-dom";
import { LogIn } from "lucide-react";
import { Logo } from "../components/Logo";

const AdminLogin = () => {
  const [params] = useSearchParams();
  const denied = params.get("error") === "access";

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin/enquiries";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="bg-[#0A2B3D] min-h-[70vh] flex items-center justify-center px-5 py-20" data-testid="admin-login-page">
      <div className="bg-white p-10 md:p-12 max-w-md w-full text-center border border-[#0A2B3D]/10 shadow-2xl">
        <div className="flex justify-center mb-6">
          <Logo variant="dark" />
        </div>
        <p className="eyebrow text-[#3E9BDC] mb-2 justify-center">Team Access</p>
        <h1 className="font-serif font-bold text-2xl text-[#0A2B3D]">Sign in to continue</h1>
        <p className="mt-3 text-sm text-[#475569] leading-relaxed">
          This area is restricted to American Elm Advisors team members with a company Google account.
        </p>
        {denied && (
          <p className="mt-4 text-sm text-red-700 bg-red-50 border border-red-200 px-4 py-3" data-testid="login-error-message">
            Access is restricted to @americanelmadvisors.com accounts.
          </p>
        )}
        <button onClick={login} data-testid="google-signin-button" className="btn-primary w-full justify-center mt-8">
          <LogIn size={16} /> Sign in with Google
        </button>
      </div>
    </div>
  );
};

export default AdminLogin;
